/**
 * API Utility - Re-exports from modular API structure
 * This file exists for backward compatibility with existing imports
 */

export * from './api/index';
